<template>
    <el-form
        :model="formData"
        :rules="rules"
        ref="stepForm"
        v-loading="loading"
    >
        <el-row :gutter="15">
            <el-col :span="24" class="form-step-title">
                <div class="steptitle">Payment</div>
            </el-col>
            <el-col :sm="24" :md="11">
                <el-radio v-model="formData.method" label="card"
                    >I want to pay with credit card</el-radio
                >
                <div v-if="formData.method == 'card'">
                    <img class="paymentcards" src="/images/cards.svg" />
                    <el-form-item label="Card Number" prop="cardnumber">
                        <el-input
                            v-model="formData.cardnumber"
                            placeholder="1111 2222 3333 4444"
                        ></el-input>
                    </el-form-item>
                    <el-row :gutter="15">
                        <el-col :span="8">
                            <el-form-item label="Exp. Month" prop="cardmonth">
                                <el-input
                                    v-model="formData.cardmonth"
                                    placeholder="MM"
                                    size="2"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Exp. Year" prop="cardyear">
                                <el-input
                                    v-model="formData.cardyear"
                                    placeholder="YY"
                                    size="2"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="CVV" prop="cvv">
                                <el-input
                                    v-model="formData.cvv"
                                    placeholder="123"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="15">
                        <el-col :span="12"> Billing Address </el-col>
                        <el-col :span="12">
                            {{ billing.address1 }}
                            {{ billing.address2 }}
                            {{ billing.city + ", " + billing.postcode }}
                            {{ billing.country }}
                        </el-col>
                        <hr />
                        <div class="bankpayment-details">
                            <strong>Notice</strong><BR /><span
                                style="color: #f39200"
                                >The information and address details of the
                                credit or debit card you will use for payment
                                must match the information entered (eg issuing
                                address, date of issue, name of holder, etc.)
                                when it was issued.</span
                            >
                        </div>
                    </el-row>
                </div>
                <hr />
                <el-radio v-model="formData['method']" label="bank"
                    >Payment method bank transfer</el-radio
                >
                <div v-if="formData.method == 'bank'" style="width: 100%">
                    <div class="banktransfer-note">
                        Wire - Electronic Bank Transfer Details
                    </div>
                    <div class="bankpayment-details">
                        All payments must be made at:<BR />
                        <strong>METROPOLITAN ARTS PRESS LTD</strong><BR /> Bank:
                        US BANK<BR /> Account Number: 1964 7758 8525<BR />
                        Routing Number: 073000545<BR /> Swift Code: USBK US 44
                        IMT<BR /> Bank Address: 270 West 7th Street Dubuque IA
                        52001-2376<BR />
                        <ul>
                            <li>
                                Please send us the bank transfer receipt with
                                your payment at
                                <a href="mailto:contact@globaldesignnews.com "
                                    >contact@globaldesignnews.com</a
                                >
                            </li>
                            <li>
                                Remember to include the reference ID number of
                                your submission
                            </li>
                            <li>
                                Entry fee for each submission is
                                <strong>{{ payAmount }}</strong
                                >. After we receive your submission and check
                                all materials an invoice will be sent to your
                                email.
                            </li>
                        </ul>
                    </div>
                    <div class="banktransfer-note">
                        Important: Add $25.00 USD for Bank Service Charges for
                        wire transfers.
                    </div>
                    <a
                        class="bankdocument"
                        href="https://awardapplication.com/pdf/Bank_Transfer_TCA_FH.pdf"
                        target="_blank"
                        >Download Bank payment details</a
                    >
                    <el-row :gutter="15">
                        <el-col :span="12"> Billing Address </el-col>
                        <el-col :span="12">
                            {{ billing.address1 }}
                            {{ billing.address2 }}
                            {{ billing.city + ", " + billing.postcode }}
                            {{ billing.country }}
                        </el-col>
                    </el-row>
                </div>
            </el-col>
            <el-col :sm="24" :md="{ span: 10, offset: 3 }">
                <div>Purchase summary</div>
                <div class="billnotice">Billed in Dollars ($)</div>
                <div class="linebill">
                    <div class="billtext">
                        One submission for Future House Award
                    </div>
                    <div class="billamount">
                        {{ payAmount }}
                    </div>
                </div>
                <hr />
                <div class="linebill">
                    <div class="billtext">Total</div>
                    <div class="billamount">
                        {{ payAmount }}
                    </div>
                </div>
                <el-button
                    v-if="formData.method == 'card'"
                    type="primary"
                    class="form-submit"
                    @click="handleSubmit"
                    >Pay now
                </el-button>
                <el-button
                    v-else
                    type="primary"
                    class="form-submit"
                    @click="handleSubmit"
                    >Complete submission
                </el-button>
                <div class="refundpolicy">
                    <a href="/refund-policy" target="_blank"
                        >Learn about our Refund Policy</a
                    >
                    <div class="invoiceto">
                        Your invoice will be sent to {{ billing.email }}
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="form-buttons"></div>
    </el-form>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => {
                return {};
            },
        },
        billing: Object,
        stepTitle: String,
        step: Number,
    },
    computed: {
        formData: {
            get() {
                return this.value;
            },
            set(newVal) {},
        },
        payAmount: function () {
            return "$" + window.future_house_amount;
        },
    },
    methods: {
        handleSubmit() {
            this.$refs.stepForm.validate((valid) => {
                if (valid) {
                    this.$emit("gosubmit");
                } else {
                    alert("Please correct the form errors before proceeding.");
                }
            });
        },
    },
    data: () => ({
        loading: false,
        rules: {
            cardnumber: [
                {
                    required: true,
                    message: "Fill in card number, with or without spaces",
                    trigger: "blur",
                },
            ],
            cardmonth: [
                {
                    required: true,
                    pattern: /^(01|02|03|04|05|06|07|08|09|10|11|12)$/i,
                    message: "Fill in 2 valid month digits",
                    trigger: "blur",
                },
            ],
            cardyear: [
                {
                    required: true,
                    pattern:
                        /^(22|23|24|25|26|27|28|29|30|31|32|33|34|35|36|37|38|39|40)$/i,
                    message: "Fill in 2 digits",
                    trigger: "blur",
                },
            ],
            cvv: [
                {
                    required: true,
                    pattern: /^[0-9]{3,4}$/i,
                    message: "Fill in 3 or 4 digits",
                    trigger: "blur",
                },
            ],
        },
    }),
};
</script>
